import { createRouter, RouterProvider } from '@tanstack/react-router'
import React from 'react'
import ReactDOM from 'react-dom/client'

import { TooltipProvider } from '@/components/ui'
import { AppError, ErrorBoundary, NotFound } from '@/modules/errors/components'
import { TrackingProvider } from '@/services/tracking'
import { routeTree } from './routeTree.gen'
import { captureException } from './services/monitoring'
import '@/services/monitoring/bootstrap'

import './styles.css'

const router = createRouter({
  routeTree,
  defaultErrorComponent: ({ error, reset, ...props }) => {
    captureException(error)
    return <AppError error={error} reset={reset} {...props} />
  },
  defaultNotFoundComponent: NotFound,
  defaultPreload: 'intent',
  scrollRestoration: 'top',
})

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <TrackingProvider>
      <ErrorBoundary fallback={({ error: props }) => <AppError {...props} />}>
        <TooltipProvider delayDuration={200}>
          <RouterProvider router={router} />
        </TooltipProvider>
      </ErrorBoundary>
    </TrackingProvider>
  </React.StrictMode>,
)
